import type { BaseOptionType } from 'antd/es/select';
import { LoadingOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { Select, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { filterOption } from '@/std/filter';
import type { ProdutoOrigem } from '../types/ProdutoOrigem';
import { apiProdutoOrigemGet } from '../api/apiProdutoOrigemGet';

export function SelectProdutoOrigem({
    disabled,
    value,
    onChange,
}: {
    disabled?: boolean;
    value?: number | null;
    onChange?: (origem: ProdutoOrigem | null) => void;
}) {
    const [options, setOptions] = useState<
        { value: number; label: string; origem: ProdutoOrigem | null }[]
    >([]);

    const { data, isFetching } = useQuery({
        queryFn: () => apiProdutoOrigemGet({}),
        queryKey: ['apiProdutoOrigemGet'],
    });

    useEffect(() => {
        setOptions(
            data?.registros.map((origem) => ({
                label: origem.pro_descricao,
                origem,
                value: origem.pro_codigo,
            })) || [],
        );
    }, [data]);

    const handleChange = (_, option: BaseOptionType | BaseOptionType[] | undefined): void => {
        if (!onChange) {
            return;
        }

        if (!option || Array.isArray(option)) {
            onChange(null);
            return;
        }

        onChange(option.origem);
    };

    return (
        <Spin indicator={<LoadingOutlined spin={true} />} spinning={isFetching}>
            <Select
                allowClear={true}
                disabled={disabled}
                filterOption={filterOption}
                onChange={handleChange}
                options={options}
                showSearch={true}
                style={{ width: '100%' }}
                value={value}
            />
        </Spin>
    );
}
